export const NAME = "layoutModule" as string;
